import { all } from "redux-saga/effects";
import { watchAppointments } from "./appointmentSaga";
import { watchDashboard } from "./dashboardSaga";
import { watchFacility } from "./facilitySaga";
import { watchLicence } from "./licenceSaga";
import { watchNotifications } from "./notificationSaga";
import { watchPatients } from "./patientSaga";
import { watchSession } from "./sessionHandler";
import { watchGetSpecialties } from "./specialtiesHandler";

export function* rootSaga() {
  yield all([
    watchSession(),
    watchDashboard(),
    watchFacility(),
    watchLicence(),
    watchAppointments(),
    watchPatients(),
    watchGetSpecialties(),
    watchNotifications(),
  ]);
}
